// Lê a duração do vídeo no navegador (player oficial do YouTube/Vimeo, invisível).
// Usado como reforço quando o servidor não consegue (YouTube bloqueia servidores;
// vídeos privados do Vimeo só abrem no domínio autorizado).
export const loadScript = (src, ready) =>
  new Promise((resolve, reject) => {
    if (ready()) return resolve();
    let s = document.querySelector(`script[src="${src}"]`);
    if (!s) { s = document.createElement("script"); s.src = src; s.async = true; document.head.appendChild(s); }
    const t0 = Date.now();
    const iv = setInterval(() => {
      if (ready()) { clearInterval(iv); resolve(); }
      else if (Date.now() - t0 > 10000) { clearInterval(iv); reject(new Error("timeout")); }
    }, 100);
  });

const hiddenBox = () => {
  const d = document.createElement("div");
  d.style.cssText = "position:fixed;left:-9999px;top:-9999px;width:320px;height:180px;opacity:0;pointer-events:none";
  document.body.appendChild(d);
  return d;
};

async function youtubeDuration(id) {
  await loadScript("https://www.youtube.com/iframe_api", () => window.YT && window.YT.Player);
  const box = hiddenBox();
  const el = document.createElement("div"); box.appendChild(el);
  return new Promise((resolve) => {
    const done = (v) => { try { player.destroy(); } catch (e) {} box.remove(); resolve(v); };
    const timer = setTimeout(() => done(null), 12000);
    const player = new window.YT.Player(el, {
      videoId: id, playerVars: { autoplay: 0, controls: 0 },
      events: {
        onReady: () => {
          let tries = 0;
          const poll = setInterval(() => {
            const d = player.getDuration ? player.getDuration() : 0;
            if (d > 0 || ++tries > 30) { clearInterval(poll); clearTimeout(timer); done(d > 0 ? Math.round(d) : null); }
          }, 200);
        },
        onError: () => { clearTimeout(timer); done(null); },
      },
    });
  });
}

async function vimeoDuration(url) {
  await loadScript("https://player.vimeo.com/api/player.js", () => window.Vimeo && window.Vimeo.Player);
  const box = hiddenBox();
  try {
    const p = new window.Vimeo.Player(box, { url, width: 320, autoplay: false, muted: true });
    const d = await Promise.race([p.getDuration(), new Promise((r) => setTimeout(() => r(null), 12000))]);
    try { p.destroy(); } catch (e) {}
    return d ? Math.round(d) : null;
  } catch (e) { return null; } finally { box.remove(); }
}

export const fmtDuration = (sec) => {
  const h = Math.floor(sec / 3600), m = Math.floor((sec % 3600) / 60), s = sec % 60;
  const pad = (n) => String(n).padStart(2, "0");
  return h ? `${h}:${pad(m)}:${pad(s)}` : `${pad(m)}:${pad(s)}`;
};

export async function detectDuration(url) {
  const u = (url || "").trim();
  const yt = u.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/|live\/)|youtu\.be\/)([\w-]{11})/);
  try {
    if (yt) return await youtubeDuration(yt[1]);
    if (/vimeo\.com\//.test(u)) return await vimeoDuration(u);
  } catch (e) { /* sem acesso ao player */ }
  return null;
}
